import React from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";

const EditDonModal = ({
  show,
  handleClose,
  selectedDon,
  setSelectedDon,
  handleAddPhuPhi,
  handleDeletePhuPhi,
  handlePhuPhiChange,
  handleSave,
}) => {
  if (!selectedDon) return null;

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Báo giá đơn {selectedDon.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          {/* General Information */}
          <Row>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Biển kiểm soát</Form.Label>
                <Form.Control type="text" value={selectedDon.bien_kiem_soat} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Ngày sửa chữa</Form.Label>
                <Form.Control
                  type="text"
                  value={new Date(selectedDon.ngay_sua_chua).toLocaleDateString()}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Loại</Form.Label>
                <Form.Control type="text" value={selectedDon.loai} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Loại xe</Form.Label>
                <Form.Control type="text" value={selectedDon.loai_xe} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>Trạm</Form.Label>
                <Form.Control type="text" value={selectedDon.tram} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>Tài xế</Form.Label>
                <Form.Control type="text" value={selectedDon.tai_xe} disabled />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Form.Group>
                <Form.Label>Ghi chú</Form.Label>
                <Form.Control as="textarea" rows={2} value={selectedDon.ghi_chu} disabled />
              </Form.Group>
            </Col>
          </Row>

          {/* Pricing Section */}
          <hr />
          <Form.Group>
            <Form.Label>Giá</Form.Label>
            <Form.Control
              type="number"
              value={selectedDon.gia}
              onChange={(e) =>
                setSelectedDon({ ...selectedDon, gia: e.target.value })
              }
            />
          </Form.Group>
          
          {/* Phu Phi Section */}
          <hr />
          <Button onClick={handleAddPhuPhi} className="mt-2">
            Thêm phụ phí
          </Button>
          {selectedDon.phu_phi.map((item, index) => (
            <Row key={index} className="mt-2 align-items-center">
              <Col md={5}>
                <Form.Control
                  type="text"
                  placeholder="Tên"
                  value={item.ten}
                  onChange={(e) => handlePhuPhiChange(index, "ten", e.target.value)}
                />
              </Col>
              <Col md={5}>
                <Form.Control
                  type="number"
                  placeholder="Giá"
                  value={item.gia}
                  onChange={(e) => handlePhuPhiChange(index, "gia", e.target.value)}
                />
              </Col>
              <Col md={2} className="text-center">
                <Button
                  variant="danger"
                  onClick={() => handleDeletePhuPhi(index)}
                  className="p-1 fit-content"
                >
                  <AiOutlineClose />
                </Button>
              </Col>
            </Row>
          ))}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleSave}>
          Báo giá
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditDonModal;
